import axiosInstance from '../core/axiosconfig';

export const getMachineGroupDetail = async (machines, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/oee/machine-group-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine group detail:', error);
    throw error;
  }
};

export const getMachineGroupOverviewInsight = async (machines, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/oee/machine-group-overview-insight?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine group overview insight:', error);
    throw error;
  }
};

export const getMachineReasonGroupDetail = async (machines, shift, fromDate, toDate, top) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const topParam = top ? `&top=${encodeURIComponent(top)}` : '';
    const url = `${baseUrl}/oee/machine-reason-group-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}${topParam}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine reason group detail:', error);
    throw error;
  }
};

export const getMachineComponentReasonGroupDetail = async (machines, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/oee/machine-component-reason-group-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine component reason group detail:', error);
    throw error;
  }
};

export const getIdleReasonEventDetail = async (machine, sessionStartTime, sessionEndTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/oee/idle-reason-event-detail?machine=${encodeURIComponent(machine)}&session_start_time=${sessionStartTime}&session_end_time=${sessionEndTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching idle reason event detail:', error);
    throw error;
  }
};

export const getMachineAlarmGroupDetail = async (machines, shift, fromDate, toDate, top) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const topParam = top ? `&top=${encodeURIComponent(top)}` : '';
    const url = `${baseUrl}/oee/machine-alarm-group-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}${topParam}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine alarm group detail:', error);
    throw error;
  }
};

export const getMachineComponentAlarmGroupDetail = async (machines, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/oee/machine-component-alarm-group-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine component alarm group detail:', error);
    throw error;
  }
};

export const getAlarmEventDetail = async (machine, sessionStartTime, sessionEndTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/oee/alarm-event-detail?machine=${encodeURIComponent(machine)}&session_start_time=${sessionStartTime}&session_end_time=${sessionEndTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching alarm event detail:', error);
    throw error;
  }
};

export const getMachineGroupOverviewInsightPdf = async (machines, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/oee/machine-group-overview-insight-pdf?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error fetching Insights3 overview PDF:', error);
    throw error;
  }
};

export const getMachineComponentGroupDetail = async (machines, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/oee/machine-component-group-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine component group detail:', error);
    throw error;
  }
};

export const getMachineComponentDateGroupDetail = async (machine, componentName, cycleTime, handlingTime, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/oee/machine-component-date-group-detail?machine=${encodeURIComponent(machine)}&component_name=${encodeURIComponent(componentName)}&cycle_time=${encodeURIComponent(cycleTime)}&handling_time=${encodeURIComponent(handlingTime)}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine component date group detail:', error);
    throw error;
  }
};

export const getComponentCycleSpeed = async (machine, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/oee/component-cycle-speed?machine=${encodeURIComponent(machine)}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component cycle speed:', error);
    throw error;
  }
};

export const getComponentCycleSpeedDetail = async (machine, shift, fromDate, toDate, sessionStartTime, sessionEndTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/oee/component-cycle-speed-detail?machine=${encodeURIComponent(machine)}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}&session_start_time=${sessionStartTime}&session_end_time=${sessionEndTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component cycle speed detail:', error);
    throw error;
  }
};

// Component Report drilldown chain (source: component_report table) - Insights4.
// method: '1' (default) = existing extra_idle-based pricing (Table 1).
// '2' = Table 2 pricing (extra_hour_cost off total idle_time, extra_part_cost off max(0, actual - target)).
export const getMachineComponentReportGroupDetail = async (machines, shift, fromDate, toDate, method = '1') => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/machine-component-report-group-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}&method=${method}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine component report group detail:', error);
    throw error;
  }
};

// Table 2 (Insights4): idle cost priced directly off total idle_time * machine_rate.
export const getMachineIdleCostDetail = async (machines, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/machine-idle-cost-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine idle cost detail:', error);
    throw error;
  }
};

// Table 2 drilldown level 1: idle cost grouped by machine + component + cycle_time + handling_time.
export const getComponentIdleCostDetail = async (machines, shift, fromDate, toDate) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/component-idle-cost-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component idle cost detail:', error);
    throw error;
  }
};

// method: '1' (default) = existing extra_idle-based pricing (Table 1).
// '2' = Table 2 pricing (extra_hour_cost off total idle_time, extra_part_cost off max(0, actual - target)).
export const getComponentReportGroupDetail = async (machines, shift, fromDate, toDate, method = '1') => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/component-report-group-detail?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}&method=${method}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component report group detail:', error);
    throw error;
  }
};

// method: '1' (default) = existing extra_idle-based pricing (Table 1).
// '2' = Table 2 pricing (extra_hour_cost off total idle_time, extra_part_cost off max(0, actual - target)).
export const getComponentReportSessions = async (machine, componentName, cycleTime, handlingTime, shift, fromDate, toDate, method = '1') => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/component/component-report-sessions?machine=${encodeURIComponent(machine)}&component_name=${encodeURIComponent(componentName)}&cycle_time=${encodeURIComponent(cycleTime)}&handling_time=${encodeURIComponent(handlingTime)}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}&method=${method}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component report sessions:', error);
    throw error;
  }
};

export const getComponentReportIdleDetail = async (machine, shift, fromDate, toDate, extra = {}) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    let url = `${baseUrl}/component/component-report-idle-detail/${encodeURIComponent(machine)}/${shift}/${fromDate}/${toDate}`;
    const params = [];
    if (extra.componentName) params.push(`component_name=${encodeURIComponent(extra.componentName)}`);
    if (extra.cycleTime !== undefined && extra.cycleTime !== null) params.push(`cycle_time=${encodeURIComponent(extra.cycleTime)}`);
    if (params.length) url += `?${params.join('&')}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component report idle detail:', error);
    throw error;
  }
};

export const getComponentReportCycleDetail = async (machine, shift, date, sessionStartTime, sessionEndTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/component/component-report-cycle-detail?machine=${encodeURIComponent(machine)}&shift=${shift}&date=${date}&session_start_time=${sessionStartTime}&session_end_time=${sessionEndTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component report cycle detail:', error);
    throw error;
  }
};

// method: '1' (default) = existing extra_idle-based pricing (Table 1).
// '2' = Table 2 pricing (extra_hour_cost off total idle_time, extra_part_cost off max(0, actual - target)).
export const getComponentReportOverviewSummary = async (machines, shift, fromDate, toDate, method = '1') => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/overview-summary?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}&method=${method}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching Insights4 overview summary:', error);
    throw error;
  }
};

export const getComponentReportManagementAttentionList = async (machines, shift, fromDate, toDate, method = '1') => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/management-attention-list?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}&method=${method}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching Insights4 management attention list:', error);
    throw error;
  }
};

export const getComponentReportOeeActualVsPotential = async (machines, shift, fromDate, toDate, method = '1') => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/oee-actual-vs-potential?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}&method=${method}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching Insights4 OEE actual vs potential:', error);
    throw error;
  }
};

export const getComponentReportOverviewPdf = async (machines, shift, fromDate, toDate, method = '1') => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/overview-pdf?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}&method=${method}`;
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error fetching Insights4 overview PDF:', error);
    throw error;
  }
};

export const getComponentReportOverviewPpt = async (machines, shift, fromDate, toDate, method = '1') => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/overview-ppt?machine=${machineParam}&shift=${shift}&from_date=${fromDate}&to_date=${toDate}&method=${method}`;
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error fetching Insights4 overview PPT:', error);
    throw error;
  }
};

// Program-report analogs of the 3 functions above - machine_name +
// start_time/end_time window instead of shift/date/method.
export const getProgramOverviewSummary = async (machines, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/program-overview-summary?machine=${machineParam}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching program overview summary:', error);
    throw error;
  }
};

export const getProgramManagementAttentionList = async (machines, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/program-management-attention-list?machine=${machineParam}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching program management attention list:', error);
    throw error;
  }
};

export const getProgramOeeActualVsPotential = async (machines, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/program-oee-actual-vs-potential?machine=${machineParam}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching program OEE actual vs potential:', error);
    throw error;
  }
};

export const getProgramOverviewPdf = async (machines, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/program-overview-pdf?machine=${machineParam}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error fetching Insights4 program overview PDF:', error);
    throw error;
  }
};

export const getProgramOverviewPpt = async (machines, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/component/program-overview-ppt?machine=${machineParam}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error fetching Insights4 program overview PPT:', error);
    throw error;
  }
};

export const getProgramReportByTime = async (machines, startTime, endTime, programName) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineList = Array.isArray(machines)
      ? machines
      : typeof machines === 'string'
      ? machines.split(',').map((m) => m.trim()).filter(Boolean)
      : [];
    const programParam = programName ? `&program_name=${encodeURIComponent(programName)}` : '';

    if (machineList.length > 1) {
      const results = await Promise.all(
        machineList.map(async (m) => {
          const url = `${baseUrl}/component/program-report-by-time?machine_name=${encodeURIComponent(m)}&start_time=${startTime}&end_time=${endTime}${programParam}`;
          const res = await axiosInstance.get(url);
          return res.data || [];
        })
      );
      return results.flat();
    } else {
      const machineParam = machineList[0] || (typeof machines === 'string' ? machines : '');
      const url = `${baseUrl}/component/program-report-by-time?machine_name=${encodeURIComponent(machineParam)}&start_time=${startTime}&end_time=${endTime}${programParam}`;
      const response = await axiosInstance.get(url);
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching program report by time:', error);
    throw error;
  }
};

export const getMachineProgramReportGroupDetail = async (machines, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineList = Array.isArray(machines)
      ? machines
      : typeof machines === 'string'
      ? machines.split(',').map((m) => m.trim()).filter(Boolean)
      : [];

    const results = await Promise.all(
      machineList.map(async (m) => {
        const url = `${baseUrl}/component/machine-program-report-group-detail?machine_name=${encodeURIComponent(m)}&start_time=${startTime}&end_time=${endTime}`;
        const res = await axiosInstance.get(url);
        return res.data || [];
      })
    );
    return results.flat();
  } catch (error) {
    console.error('Error fetching machine program report group detail:', error);
    throw error;
  }
};

export const getProgramReportGroupDetail = async (machineName, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/component/program-report-group-detail?machine_name=${encodeURIComponent(machineName)}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching program report group detail:', error);
    throw error;
  }
};

export const getAllProgramReportGroupDetail = async (machines, startTime, endTime) => {
  try {
    const machineList = Array.isArray(machines)
      ? machines
      : typeof machines === 'string'
      ? machines.split(',').map((m) => m.trim()).filter(Boolean)
      : [];

    const results = await Promise.all(
      machineList.map((m) => getProgramReportGroupDetail(m, startTime, endTime))
    );
    return results.flat();
  } catch (error) {
    console.error('Error fetching all program report group detail:', error);
    throw error;
  }
};

export const getProgramPartDetail = async (machineName, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/component/program-part-detail?machine_name=${encodeURIComponent(machineName)}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching program part detail:', error);
    throw error;
  }
};

// Method 4 (program_transaction / pms_program_report drilldown) - see
// Machine.controller.ts / Machine.service.ts on the tb-node-mtlinki backend.
export const getProgramTransactions = async (machineName, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/program-transactions?machine_name=${encodeURIComponent(machineName)}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching program transactions:', error);
    throw error;
  }
};

export const getPmsProgramReportByTransaction = async (programTransactionId, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/pms-program-report-by-transaction?program_transaction_id=${encodeURIComponent(programTransactionId)}${startTime ? `&start_time=${startTime}` : ''}${endTime ? `&end_time=${endTime}` : ''}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching pms_program_report by transaction:', error);
    throw error;
  }
};

// Per-reason excess breakdown (duration - threshold, enabled reasons
// excluded) - backs the Method 4 Reason pareto chart, matches the
// Excess Reason Time column exactly since it's the same underlying rule.
export const getExcessReasonBreakdown = async (machineName, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/excess-reason-breakdown?machine_name=${encodeURIComponent(machineName)}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching excess reason breakdown:', error);
    throw error;
  }
};

// Per-alarm-message breakdown - backs the Overview page's Top Alarm
// management action.
export const getAlarmBreakdown = async (machineName, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/alarm-breakdown?machine_name=${encodeURIComponent(machineName)}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching alarm breakdown:', error);
    throw error;
  }
};

// The single program_transaction with the most idle time for a machine -
// backs the Overview page's Top Idle Program management action.
export const getTopIdleProgram = async (machineName, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/top-idle-program?machine_name=${encodeURIComponent(machineName)}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching top idle program:', error);
    throw error;
  }
};

// Read-only breakdown of how cycle_time/handling_time were auto-computed
// for a program_transaction (the full tolerance-clustering result, not
// just the winning cluster) - backs the "how was this calculated?" info
// popup on the Table tab.
export const getCycleTimeCalculation = async (programTransactionId) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/cycle-time-calculation?program_transaction_id=${programTransactionId}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching cycle time calculation:', error);
    throw error;
  }
};

// Read-only breakdown of how one shift's Extra Idle Time / Extra Idle Time
// (Net) were computed - the per-part idle-vs-target list and the
// per-reason mandatory-idle breakdown - backs the shift row's own "how was
// this calculated?" info popup.
export const getExtraIdleTimeCalculation = async (pmsProgramReportId) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/extra-idle-time-calculation?pms_program_report_id=${pmsProgramReportId}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching extra idle time calculation:', error);
    throw error;
  }
};

// PDF export of the Method 4 Overview tab - same data source as the
// Overview tab itself, so the PDF always matches what's on screen.
export const getProgramTransactionOverviewPdf = async (machines, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${baseUrl}/machine/program-transaction-overview-pdf?machine=${machineParam}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error fetching program transaction overview PDF:', error);
    throw error;
  }
};

// Update button on the Method 4 drilldown: sets cycle_time/handling_time/
// setup_time (seconds) directly on a program_transaction row.
export const updateProgramTransactionTimes = async (programTransactionId, cycleTime, handlingTime, setupTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/update-program-transaction-times?program_transaction_id=${encodeURIComponent(programTransactionId)}&cycle_time=${cycleTime}&handling_time=${handlingTime}&setup_time=${setupTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error updating program transaction times:', error);
    throw error;
  }
};

// Lock icon on the Method 4 drilldown: clears manual_cycle_time and
// immediately reprocesses, handing cycle_time/handling_time back to the
// auto-clustering algorithm.
export const unlockCycleTime = async (programTransactionId) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/unlock-cycle-time?program_transaction_id=${encodeURIComponent(programTransactionId)}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error unlocking cycle time:', error);
    throw error;
  }
};

// Toggle for a non-production shift (e.g. machine on leave that whole
// shift) - false excludes it from every rollup while keeping it visible.
export const updateShiftProductionFlag = async (pmsProgramReportId, isProduction) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/update-shift-production-flag?pms_program_report_id=${encodeURIComponent(pmsProgramReportId)}&is_production=${isProduction}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error updating shift production flag:', error);
    throw error;
  }
};

// Reprocesses one program_transaction into pms_program_report - called
// after updateProgramTransactionTimes saves, so low_cycle/normal_cycle/
// high_cycle etc refresh in the same click instead of needing a separate
// process-program-transactions run.
export const processSingleTransaction = async (programTransactionId) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const url = `${baseUrl}/machine/process-transaction?program_transaction_id=${encodeURIComponent(programTransactionId)}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error reprocessing program transaction:', error);
    throw error;
  }
};

// Drilldown level 0 for Method 4: one row per machine, summed across every
// one of that machine's program_transaction rows.
export const getMachineProgramSummary = async (machineNames, startTime, endTime) => {
  try {
    const baseUrl = window._env_.SERVER_URL2.replace(/\/$/, '');
    const machineParam = Array.isArray(machineNames) ? machineNames.join(',') : machineNames;
    const url = `${baseUrl}/machine/program-transactions-machine-summary?machine_name=${encodeURIComponent(machineParam)}&start_time=${startTime}&end_time=${endTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching machine program summary:', error);
    throw error;
  }
};
